import React from 'react'
import List from '../../ListView/List'
import WeekView from '../../WeekView'

const EventDetails = ({
  currentWeekStart,
  currentWeekEnd,
  calendarRef,
  currentToggle,
  state,
  handleOccurrenceClick,
  setState,
  fetchEventsList,
  setListDate,
  listDate,
  handleSortByChange,
  handleSearch,
  handleSingleEventClick,
  handleRegistrationClick,
  studentDetails,
  calenderData,
}) => {
  return (
    <>
      {currentToggle === 'left' ? (
        <List
          state={state}
          handleOccurrenceClick={handleOccurrenceClick}
          setState={setState}
          setListDate={setListDate}
          listDate={listDate}
          fetchEventsList={fetchEventsList}
          handleSortByChange={handleSortByChange}
          handleSearch={handleSearch}
          handleSingleEventClick={handleSingleEventClick}
          handleRegistrationClick={handleRegistrationClick}
          studentDetails={studentDetails}
        />
      ) : (
        <WeekView
          currentWeekStart={currentWeekStart}
          currentWeekEnd={currentWeekEnd}
          calendarRef={calendarRef}
          eventList={calenderData}
          handleRegistrationClick={handleRegistrationClick}
          handleSingleEventClick={handleSingleEventClick}

        />
      )}
    </>
  )
}

export default EventDetails
